const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    width: "4.2023602mm",
    height: "10.9534mm",
    viewBox: "0 0 4.2023602 10.9534",
    id: "svg4568",
    "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
    "sodipodi:docname": "next_icon.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs4562"
  }), /*#__PURE__*/React.createElement("sodipodi:namedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    "inkscape:pageopacity": 0,
    "inkscape:pageshadow": 2,
    "inkscape:zoom": 0.35,
    "inkscape:cx": 7.941467,
    "inkscape:cy": 20.699326,
    "inkscape:document-units": "mm",
    "inkscape:current-layer": "layer1",
    showgrid: "false",
    "inkscape:window-width": 2880,
    "inkscape:window-height": 1674,
    "inkscape:window-x": 0,
    "inkscape:window-y": 60,
    "inkscape:window-maximized": 1
  }), /*#__PURE__*/React.createElement("metadata", {
    id: "metadata4565"
  }, /*#__PURE__*/React.createElement("rdf:RDF", null, /*#__PURE__*/React.createElement("cc:Work", {
    "rdf:about": ""
  }, /*#__PURE__*/React.createElement("dc:format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dc:type", {
    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dc:title", null)))), /*#__PURE__*/React.createElement("g", {
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    id: "layer1",
    transform: "translate(83.366061,-143.35663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -83.289215,154.31003 v -10.9534",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 0.15369152,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path388",
    "inkscape:connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -81.536968,151.13433 2.213328,-2.30117 -2.213328,-2.30082",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 0.23053746,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path398",
    "inkscape:connector-curvature": 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next_icon.d252f4418512115d4af4a915ca0430b1.svg";
export { ForwardRef as ReactComponent };